import BaseService from "./BaseService";

class InternalToolsService extends BaseService {
    constructor(baseUrl: string) {
        super(baseUrl)
    }

    updateLead = (body) => this.requests.put('/firstpromoter/lead', body)

    removePromoterForLead = (leadUID) => this.requests.post(`/firstpromoter/lead/${leadUID}/remove-promoter`, {})

    createPaymentIntent = (body) => this.requests.post(`/billing/payment-intent`, body)

    getDowngradableAgencyPlan = (companyId) => this.requests.get(`/billing/agency-plan/${companyId}/downgradable-plan`)

    downgradeAgencyPlan = (body) => this.requests.post('/billing/agency-plan/downgrade', body)

    getWaitTime = () => this.requests.get('/freshwork/chat/wait-time')

    verifyPaymentMethod = (body) => this.requests.post('/billing/verify-paymentmethod',body)

    getHipaaDetails = (companyId) => this.requests.get(`/compliance/get-hipaa-detail/${companyId}`)

    searchPartners = (filter) => this.requests.post(`/partners/search`, filter)

    addOrUpdatePartner = (payload) => this.requests.post('/partners/update', payload)

    deletePartner = (partnerId) => this.requests.delete(`/partners/${partnerId}`)

    addPartnerContact = (payload) => this.requests.post('/partners/add-contact', payload)

    sendEmail = (payload) => this.requests.post('/partners/email', payload)
}

const instance = new InternalToolsService(BaseService.servicesConfig.InternalTools)

export default instance